import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import APropos from '../components/APropos';
import CongressObjectives from '../components/CongressObjectives';
import CongressTopics from '../components/CongressTopics';
import CongressDates from '../components/CongressDates';
import Speakers from '../components/Speakers';
import SpeakersOnline from '../components/SpeakersOnline';
import Contact from '../components/Contact';
import NosFlyers from '../components/NosFlyers';
import ProgrammeConference from '../components/ProgrammeConference';
import MediaPreview from '../components/MediaPreview';
import GSIDAAcademicChallenge from '../components/GSIDAAcademicChallenge';
import Formation from '../components/Formation';

function Accueil({ onNavigate }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hero onNavigate={onNavigate} />
      <ProgrammeConference />
       <MediaPreview onNavigate={onNavigate}  />
      <APropos />
      <Speakers />
     
      <CongressTopics />
      <CongressObjectives />
      <CongressDates />
      <GSIDAAcademicChallenge />
      <Formation />
      <NosFlyers />
      <Contact />
      {/* <SpeakersOnline /> */}
      
      <main className="accueil">
        {/* Main content for homepage */}
      </main>
    </div>
  );
}

export default Accueil;
